/**
 *      Arquivo responsável por guardar todos os end-point que serão requisitados
 *          pelo módulo
 */

export default {
    getGeneralFaculty: { method: 'get', url: 'api/secure/professor'},
}